import React from 'react';
import { Text } from '@/components/ui';
import dayjs from 'dayjs';

interface DateCellProps {
  value?: unknown;
  format?: string; // dayjs format string
  showTime?: boolean;
  render?: () => React.ReactNode;
}

function DateCell({ value, format, showTime = false, render }: DateCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  if (!value) {
    return (
      <Text size="2" color="gray">
        —
      </Text>
    );
  }

  let date: dayjs.Dayjs;
  
  if (value instanceof Date) {
    date = dayjs(value);
  } else if (typeof value === 'string' || typeof value === 'number') {
    date = dayjs(value);
  } else {
    return (
      <Text size="2" color="gray">
        Invalid date
      </Text>
    );
  }

  if (!date.isValid()) {
    return (
      <Text size="2" color="gray">
        Invalid date
      </Text>
    );
  }

  let formattedDate: string;

  if (format) {
    formattedDate = date.format(format);
  } else if (showTime) {
    formattedDate = date.format('MMM D, YYYY h:mm A');
  } else {
    formattedDate = date.format('MMM D, YYYY');
  }

  return (
    <Text size="2" className="data-cell__date">
      {formattedDate}
    </Text>
  );
}

export default DateCell;
